import React from 'react';
import { getUpcomingPayerList } from 'api/credentialing';
import { TKlarityPayer } from 'types/credentialing';

let globalData: TKlarityPayer[] = [];

const useUpcomingPayers = (states?: string[]): [TKlarityPayer[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TKlarityPayer[]>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getUpcomingPayerList(states);
            if (!result.error) {
                const list: TKlarityPayer[] = result?.data?.data || [];
                globalData = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [states]);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useUpcomingPayers;
